import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-975e681e")

_pushScopeId("data-v-975e681e")
const _hoisted_1 = { class: "modal-download-rate" }
const _hoisted_2 = { class: "space-y-2" }
const _hoisted_3 = { class: "text-12px xxl:text-14px text-gray-lp-500 w-full pt-2" }
const _hoisted_4 = { class: "w-full flex flex-col gap-2 md:gap-0 md:flex-row py-5" }
const _hoisted_5 = { class: "w-full md:w-9/12 lg:w-6/12" }
const _hoisted_6 = { class: "text-black-lp-300 font-semibold text-12px xxl:text-14px mb-2" }
const _hoisted_7 = { class: "lg:mr-6 custom-input-product" }
const _hoisted_8 = { class: "w-full lg:w-6/12" }
const _hoisted_9 = { class: "text-black-lp-300 font-semibold text-12px xxl:text-14px md:mb-2 lg:ml-6 mb-2" }
const _hoisted_10 = { class: "lg:ml-6" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Select = _resolveComponent("Select")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_ModalForm = _resolveComponent("ModalForm")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.isShow)
        ? (_openBlock(), _createBlock(_component_ModalForm, {
            key: 0,
            onClose: _ctx.onClose,
            onSubmit: _ctx.goDownload,
            title: _ctx.$t('shipmentRates.titleMenuDownload'),
            isScroll: false,
            isFooter: true,
            isIcon: true,
            icons: "document-download-outline-white",
            buttonTitle: 'Download',
            isDisabled: _ctx.isDisabled
          }, {
            content: _withId(() => [
              _createVNode("div", _hoisted_2, [
                _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("shipmentRates.subtitleMenuDownload")), 1),
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("shipmentRates.titleShipmentType")), 1),
                    _createVNode("div", _hoisted_7, [
                      _createVNode(_component_Select, {
                        dataSelect: _ctx.productListData,
                        onOpenSelect: () => _ctx.onOpenProductSelect(true),
                        onCloseSelect: () => _ctx.onOpenProductSelect(false),
                        onChooseSelect: _ctx.onSelectProduct,
                        value: _ctx.productName,
                        isOpenMenu: _ctx.productSelect,
                        class: "w-full z-20"
                      }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("shipmentRates.titleCommodityType")), 1),
                    _createVNode("div", _hoisted_10, [
                      _createVNode(_component_SelectSearch, {
                        onFocus: _ctx.onGetCommodityList,
                        onFilter: _ctx.fetchCommodity,
                        isLoading: _ctx.loadingCommodity,
                        options: _ctx.commodityList,
                        keyName: "commodity_name",
                        keyValue: "commodity_id",
                        placeholder: _ctx.$t('shipmentRates.placeholderSelectCommodity'),
                        modelValue: _ctx.filterData.commodity,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterData.commodity = $event)),
                        onChange: _ctx.onChangeCommodity,
                        class: "w-full z-20"
                      }, null, 8, ["onFocus", "onFilter", "isLoading", "options", "placeholder", "modelValue", "onChange"])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onClose", "onSubmit", "title", "isDisabled"]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.outBack,
      onClose: _ctx.outCancel,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isTerminated]
    ])
  ], 64))
})